import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  InputLabel,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import { Grid, TextField, MenuItem, Autocomplete, Box } from "@mui/material";

import DateFnsUtils from "@date-io/date-fns";

import { makeStyles } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { format, subDays } from "date-fns";

import ApiService from "../../ApiService";
import {
  InfoOutlined as InfoOutlinedIcon,
  SettingsBackupRestore as ReverseIcon,
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  head: {
    backgroundColor: theme.palette.action.hover,
  },
  table: {
    marginTop: 40,
    marginLeft: 20,
    minWidth: "97%",
    maxWidth: "97%",
  },
}));

const WireSummaryComponent = () => {
  const classes = useStyles();
  const [failed, setFailed] = useState(false);
  const [success, setSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [fromDate, setFromDate] = useState(subDays(new Date(), 20));
  const [toDate, setToDate] = useState(new Date());
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [numberRowPerPage, setNumberRowPerPage] = useState(20);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [result, setResult] = useState(null);
  const [terminals, setTerminals] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState(null);

  useEffect(() => {
    fetchAllMerchants();
  }, []);

  useEffect(() => {
    if (success || failed) {
      const timer = setTimeout(() => {
        setSuccess(false);
        setFailed(false);
        setResponseMessage("");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [success, failed]);

  const fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      setMerchants(res.data);
    });
  };
  const handleTerminalChange = (event) => {
    setSelectedTerminal(event.target.value);
  };

  const handleMerchantChange = (event, newValue) => {
    const selectedMer = newValue ? newValue.id : null;
    if (selectedMer) {
      setSelectedMerchant(selectedMer);
      showTerminalsById(selectedMer);
    } else {
      setSelectedTerminal(null);
      setSelectedMerchant(null);
      setTerminals([]);
      setResult(null);
    }
  };

  const handleClose = () => {
    setLoading(false);
  };
  const searchWireSummary = () => {
    setPageNumber(0);
    if (
      fromDate === null ||
      toDate === null ||
      selectedMerchant === null ||
      selectedTerminal === null
    ) {
      setFailed(true);
      setResponseMessage(
        "From Date,To date, Merchant and Terminal are mandatory to select."
      );
    } else {
      reloadTransactions(0);
    }
  };

  const reloadTransactions = (pageNo) => {
    setLoading(true);
    ApiService.fetchWireSummary(
      format(fromDate, "yyyyMMdd"),
      format(toDate, "yyyyMMdd"),
      selectedTerminal
    ).then((res) => {
      if (res !== null) {
        setResult(res.data.responseEntity);
        setLoading(false);
        setTotalRow(res.data.totalRow);
      }
    });
  };

  const showTerminalsById = (merchantId) => {
    if (merchantId || merchantId !== null) {
      ApiService.fetchMerchantTerminalsByMerId(merchantId)
        .then((res) => {
          setTerminals(res.data);
        })
        .catch((e) => {});
    }
  };

  return (
    <>
      <Paper style={{ margin: "1em", padding: "1em" }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          Wire Summary
        </Typography>
        {failed && (
          <Alert severity="error" elevation="0">
            {" "}
            {responseMessage}
          </Alert>
        )}
        {success && (
          <Alert severity="success" elevation="0">
            {" "}
            {responseMessage}
          </Alert>
        )}

        <Divider light className={classes.searchbar} />

        <Box>
          <Grid container spacing={2} style={{ marginTop: 10 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid item xs={6} sm={6} md={3} lg={2}>
                <DatePicker
                  autoOk
                  label="From Date"
                  format="MM/dd/yyyy"
                  value={fromDate}
                  onChange={(newValue) => setFromDate(newValue)}
                  style={{ width: "150px" }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={2}>
                <DatePicker
                  autoOk
                  label="To Date"
                  format="MM/dd/yyyy"
                  value={toDate}
                  onChange={(newValue) => setToDate(newValue)}
                  style={{ width: "150px" }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                options={merchants}
                getOptionLabel={(option) =>
                  option ? option.merchantName + "-" + option.code : ""
                }
                value={
                  merchants.find(
                    (merchant) => merchant.id === selectedMerchant
                  ) || null
                }
                style={{ marginTop: "3px" }}
                onChange={handleMerchantChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Merchants"
                    fullWidth
                    variant="standard"
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <FormControl
                sx={{
                  width: {
                    xs: "25%",
                    sm: "50%",
                    md: "75%",
                    lg: "250px",
                    xl: "100%",
                  },
                }}
                variant="standard"
              >
                <InputLabel id="terminal-label">Terminal</InputLabel>
                <Select
                  labelId="terminal-label"
                  id="terminal-select"
                  value={selectedTerminal}
                  onChange={handleTerminalChange}
                  label="Terminal"
                >
                  {terminals.map((terminal) => (
                    <MenuItem
                      key={terminal.terminalId}
                      value={terminal.terminalId}
                    >
                      {terminal.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{
                  marginTop: "18px",
                  marginLeft: "60%",
                  width: "70%",
                }}
                className={classes.button}
                startIcon={<SearchIcon style={{ fontSize: "1.2em" }} />}
                onClick={searchWireSummary}
                fullWidth
              >
                Search
              </Button>
              <Backdrop
                open={loading}
                className={classes.backdrop}
                onClick={handleClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Grid>

            {result && (
              <TableContainer component={Paper}>
                <Table aria-label="simple table" className={classes.table}>
                  <TableHead className={classes.head}>
                    <TableRow>
                      <TableCell>Category</TableCell>
                      <TableCell align="right">Count</TableCell>
                      <TableCell align="right">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        Successful Transactions
                      </TableCell>
                      <TableCell align="right">{result.successCount}</TableCell>
                      <TableCell align="right">
                        {result.successAmount}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Failed Transactions</TableCell>
                      <TableCell align="right">
                        {result.failedTxnCount}
                      </TableCell>
                      <TableCell align="right">
                        {result.failedTxnAmount}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Refund Transactions</TableCell>
                      <TableCell align="right">{result.refundCount}</TableCell>
                      <TableCell align="right">{result.refundAmount}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">
                        Chargeback Transactions
                      </TableCell>
                      <TableCell align="right">
                        {result.chargeBackCount}
                      </TableCell>
                      <TableCell align="right">
                        {result.chargeBackAmount}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell align="left">Rolling Reserve</TableCell>
                      <TableCell align="right">
                        {result.rollingReserveCount}
                      </TableCell>
                      <TableCell align="right">
                        {result.rollingReserveAmount}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Box>
      </Paper>
    </>
  );
};

export default WireSummaryComponent;
